export default "__VITE_ASSET__YRJC5OPj__"